import {default as _private} from "./private"; 
import {default as _public} from "./public"; 
import unprotected from "./unprotected"; 

export default {
  private: _private,
  public: _public,
  unprotected
}